import { graphql } from "relay-runtime"

export const deCreateCallCaseSummaryFeedbackMutation = graphql`
  mutation deCreateCallCaseSummaryFeedbackMutation($input: De_createCallCaseSummaryFeedbackInput!) {
    de_createCallCaseSummaryFeedback(input: $input) {
      callCaseSummaryFeedback {
        appointmentId
        createdAt
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
